import React from 'react'
import { useTranslation } from 'react-i18next'

interface TicketAssignDetailProps {
  type: string
  assignDate: string
}

function TicketAssignDetail(props: TicketAssignDetailProps): JSX.Element {
  const { type, assignDate } = props
  const { t } = useTranslation('ticket')

  const base = 'f-ticket-assign-modal'

  return (
    <div className={`${base}__content-detail`}>
      <div>
        <span className={`${base}__content-detail-title`}>
          {t('type.title')}
        </span>
        <span className={`${base}__content-detail-value`}>{type}</span>
      </div>

      <div>
        <span className={`${base}__content-detail-title`}>
          {t('requestDate.title')}
        </span>
        <span className={`${base}__content-detail-value`}>{assignDate}</span>
      </div>
    </div>
  )
}

export default TicketAssignDetail
